module.exports = __webpack_public_path__ + "static/media/arla-protein-logo-80x57.7278aa92.svg";